import React, {useState} from "react";
import {priceRulesBaseUrl} from "../../../config/generals";
import {
    AlertTypes,
    apiClient,
    DynamicDatagrid,
    GenericItemsUtils,
    Grid,
    IAlertData,
    MuiDataGrid,
    MuiIcons,
    setAlert,
    SmartInput,
    Leap4Breadcrumbs,
    Button,
    Paper,
    Search as SearchIcon
} from "@leap4/frontend";
import {connect, ConnectedProps} from "react-redux";
import {setIsLoading} from "../../../store/actions/dateRange.actions";
import {ILoadingComponents} from "../../../interfaces/datesGlobalState.interface";
import {urlService} from "../../routing/urlsService";
import {IPriceRulePopulatedAmount} from "./PriceRules.interface";
import {useHistory} from "react-router-dom";
import RegexParser from 'regex-parser';
import {useQuery} from "react-query";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";

const {PriceCheck: PriceCheckIcon} = MuiIcons;
type GridColDef = MuiDataGrid.GridColDef;

const mapStateToProps = () => ({});

const mapActions = {
    setIsLoading,
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface IPriceRulesDashProps extends PropsFromRedux {
    setIsLoading: (isLoading: Partial<ILoadingComponents>) => void
    setAlert: (alert: IAlertData) => void
}

const fields = {
    name: 1,
    regex: 1,
    rule: 1,
    amountOfTags: 1,
    created: 1,
    updated: 1,
    isActive: 1,
}

const _PriceRulesDashboard = (props: IPriceRulesDashProps) => {
    const {setAlert} = props;
    const [allPriceRules, setAllPriceRules] = useState<Array<IPriceRulePopulatedAmount>>([])
    const [priceRulesForTable, setPriceRulesForTable] = useState<Array<IPriceRulePopulatedAmount>>([])
    const [stringForSearch, setStringForSearch] = useState<string>('')
    const history = useHistory()

    const handleActivation = async (e) =>{
        try{
            const currentTagStatus = allPriceRules.find(priceRule => priceRule._id === e).isActive
           await apiClient.patch(`${priceRulesBaseUrl}/${e}/active`, {isActive: !currentTagStatus})
            await refetchAllPriceRules()
        } catch (err){
            setAlert({msg: 'Could not change activation', type: AlertTypes.FAILURE})
        }

    }

    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${priceRulesBaseUrl}`
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editPriceRule(id)},
        isActive: {activationFunc: handleActivation},
        updated: {},
        created: {}
    })

    let columns: GridColDef[];
    columns = storeAndColumns.columns;


    const handleStringSearchChange = (e) =>{
        const {value} = e.target
        setStringForSearch(value)
        calcPriceRulesForTable(allPriceRules, value)
    }

    //Get a filtered array of the test-validated regexes for that string
    const calcPriceRulesForTable = (newPriceRules: Array<IPriceRulePopulatedAmount>, stringForSearch: string) =>{
        if(!stringForSearch) return setPriceRulesForTable(newPriceRules);
        const filteredPriceRules: Array<IPriceRulePopulatedAmount> = newPriceRules.filter(priceRule =>{
            const priceRuleRegex = RegexParser(priceRule.regex);
            return priceRuleRegex.test(stringForSearch)
        })
        setPriceRulesForTable(filteredPriceRules)
    }

    const fetchAllPriceRules = async () => {
            const baseUrl = `${priceRulesBaseUrl}`
            const priceRules = (await apiClient.get(baseUrl)).data.results
            priceRules.forEach(pricerule => pricerule.id = pricerule._id)
            setAllPriceRules(priceRules)
            calcPriceRulesForTable(priceRules, stringForSearch)
    }

    const {isLoading: isLoadingInitialData, refetch: refetchAllPriceRules} = useQuery(
        'fetch-all-price-rules-query',
        fetchAllPriceRules,
        {
            refetchOnWindowFocus: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE}),
            cacheTime: 0
        });

    const isLoading = isLoadingInitialData

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[
                {
                    text: "Price Rules Dashboard",
                    icon: <PriceCheckIcon />
                }
            ]} />
            <Paper elevation={5} style={{ borderRadius: "16px", boxShadow: 'none', padding: 10}}>
            <Grid container direction={'column'}>
                <Grid container justifyContent={'space-between'} width={'100%'} alignItems={'center'}>
            <SmartInput startAdornment={<SearchIcon />} value={stringForSearch} onChange={handleStringSearchChange} muiProps={{sx: {marginBottom: 1}}}/>
                    <Button size={'large'} onClick={()=>history.push('/pricerules/add')} variant={'outlined'}>Create New Price Rule</Button>
                </Grid>
            <DynamicDatagrid
                refreshFunc={fetchAllPriceRules}
                loading={isLoading}
                columns={columns}
                rows={priceRulesForTable}
                loadError={false}
            />
            </Grid>
            </Paper>
        </>
    )
}
export const PriceRulesDashboard =  connector(_PriceRulesDashboard)